import { Component } from '@angular/core';

import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';
import { Population, SelectedItem } from '../../../../user/population-select';
import { ReportType } from '../../../backend';
import { currentBuilderState } from '../../builder.state';
import { updateSectionLabels } from '../../function/update-section-labels.function';
import { BuilderState } from '../../model/builder-state.model';
import { SelectionService } from '../../service/selection.service';

@Component({
    selector: 'cmps-report-builder-report-type',
    templateUrl: './report-type.component.html',
})
@TakeUntilDestroy()
export class ReportTypeComponent {
    /** @private */
    readonly _ReportType = ReportType;

    /** @private */
    readonly _Population = Population;

    /** @private */
    _state: BuilderState;

    constructor(private readonly _selectionService: SelectionService) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onChange(): void {
        this._selectionService.onReportTypeChange();
    }

    /** @private */
    _onRoleLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            role: value,
        });
    }

    /** @private */
    _onTeamLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            team: value,
        });
    }

    /** @private */
    _onIndividualLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            individual: value,
        });
    }
}
